// NetworkBanner.jsx
import React from 'react';
import { Banner } from './style';

export default function NetworkBanner({ status, lastRtt }) {
  if (status === 'good' || status === 'unknown') return null;

  const color = status === 'offline' ? 'red' : 'yellow';
  const msg =
    status === 'offline'
      ? 'Você está offline. Algumas ações podem não funcionar até a conexão voltar.'
      : `Sua conexão parece lenta${lastRtt ? ` (~${Math.round(lastRtt)} ms)` : ''}. Operações podem demorar.`;

  return <Banner color={color}>{msg}</Banner>;
}
